import { extend } from 'vee-validate';

extend('pwdRule', value => {
  var strongRegex = new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[\s\S]{6,20}$/);
  return strongRegex.test(value);
});

extend('otpRule', value => {
  var strongRegex = new RegExp(/^\d{6}$/);
  return strongRegex.test(value);
});

extend('txnPwdValid', value => {
  var strongRegex = new RegExp(/^(?=.*\d)(?=.*[A-Z])(?=.*[a-z]).{6,20}$/);
  return strongRegex.test(value);
});

extend('not_same', (value1, value2) => {
  return value1 != value2;
});

